module.exports = __webpack_public_path__ + "3241d36f93abe14bed30f95c923e5047.png";